import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuth } from '../hooks/AuthContext';

import DefaultLayout from '../pages/_layouts/DefaultLayout';
import AuthLayout from '../pages/_layouts//AuthLayout';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {

  const { user } = useAuth();

  const signed = !!user;

  if (!signed && isPrivate) {
    return <Redirect to="/" />
  }


  const Layout = signed ? DefaultLayout : AuthLayout;

  return (
    <Route {...rest} render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )} />
  );
}
